import React, { useState } from "react";
import "../styles/CustomerReviews.css";

const CustomerReviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Liste des avis clients
  const reviews = [
    {
      name: "Alice L.",
      review:
        "Le B01 est top. Je me sens beaucoup plus en sécurité sur ma trottinette.",
      rating: 5,
    },
    {
      name: "Thomas M.",
      review:
        "Un design élégant et des fonctionnalités vraiment utiles.",
      rating: 4,
    },
    {
      name: "Manon D.",
      review:
        "Les produits sont bien conçus, mais j'aurais aimé plus de choix de couleurs. Sinon, tout fonctionne parfaitement !",
      rating: 4,
    },
    {
      name: "Éric B.",
      review:
        "La livraison a été rapide et les instructions d'installation sont claires. Je recommande !",
      rating: 5,
    },
    // {
    //   name: "Julie G.",
    //   review:
    //     "J'ai acheté le casque Baltee. La lumière intégrée est très pratique la nuit.",
    //   rating: 5,
    // },
    // {
    //   name: "Lucas F.",
    //   review:
    //     "Service client réactif et produits de très bonne qualité. Les clignotants sur le casque on changé ma façon de rouler en ville.",
    //   rating: 5,
    // },
    {
      name: "Clara P.",
      review:
        "Très bon rapport qualité/prix. Les fonctionnalités connectées sont un vrai plus pour les trajets quotidiens.",
      rating: 4,
    },
  ];
  

  // Fonction pour changer d'avis
  const nextReview = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="review-slider-container">
      <button className="slider-button prev" onClick={prevReview}>
        ❮
      </button>
      <div className="review">
        <h3 className="customer-name">{reviews[currentIndex].name}</h3>
        <p className="customer-review">"{reviews[currentIndex].review}"</p>
        <div className="customer-rating">
          {"⭐".repeat(reviews[currentIndex].rating)}
        </div>
      </div>
      <button className="slider-button next" onClick={nextReview}>
        ❯
      </button>
    </div>
  );
};

export default CustomerReviews;
